var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-container"},[_c('item-tip'),_c('div',{staticClass:"content-wrapper"},[_c('tip-ete',{attrs:{"title":_vm.title}}),(_vm.list.length)?_c('new-list',{attrs:{"list":_vm.list,"show-more":_vm.showMore,"stype":_vm.newskey},on:{"articleClick":_vm.articleClick}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }